<template>
  <div class="login wh100 flex_center hidden pr">
    <div class="wrap white flex">
      <div class="login_left">
        <img src="@/assets/login_new_left.png" class="login_left_img">
      </div>
      <div class="login_right flex1">
        <!-- <div class=" flex login_code_pr" v-if="!isCode && !iswxName">
          <div class="login_code mr15" @click="showCode">
          <img src="@/assets/login_code.png" class="code" />
        </div>
        <el-tooltip effect="dark" content="点击左侧图标二维码扫码登陆" placement="top">
            <i class="el-icon-info c9 fs14"></i>
          </el-tooltip>
        </div>
        <div class=" flex login_code_pr" v-if="isCode && iswxName">
          <div class="login_code mr15" @click="showAccount">
          <img src="@/assets/login_account.png" class="code" />
        </div>
        <el-tooltip effect="dark" content="账号密码登录" placement="top">
            <i class="el-icon-info c9 fs14"></i>
          </el-tooltip>
        </div> -->
        <!-- <div v-if="!isCode"> -->
        <template v-if="!isMultiple">
          <ul class="tabList pointer flex_middle">
            <li class="lh36 fs18 c6" :class="{active: activeIndex === 0}" @click="toggleTab(0)">账密登录</li>
            <el-divider direction="vertical" />
            <li class="lh36 fs18 c6" :class="{active: activeIndex === 1}" @click="toggleTab(1)">验证码登录</li>
          </ul>
          <el-form v-if="activeIndex === 0" ref="form" :model="form" :rules="rules" class="login-form">
            <el-form-item prop="account">
              <el-input v-model.trim="form.account" type="text" placeholder="请输入账号" clearable prefix-icon="el-icon-user" @input="inputPass" @keyup.native.13="next" />
            </el-form-item>
            <el-form-item prop="pass">
              <el-input ref="pass" v-model.trim="form.pass" type="password" placeholder="请输入密码" show-password prefix-icon="el-icon-lock" @input="inputPass" @keyup.native.13="submitForm('form')" />
            </el-form-item>
            <el-form-item v-if="form.account && form.pass && slideFormDrawing" prop="slide">
              <div class="flex_center c6 success_button">
                <i class="el-icon-check mr5 fs16" />
                验证成功
              </div>
            </el-form-item>
            <el-form-item v-else prop="slide">
              <div class="flex_center c6 check_button" @click="slideFormCheck">
                <i class="el-icon-help mr5 fs16" />
                点击按钮完成验证
              </div>
            </el-form-item>
            <el-form-item>
              <div class="w100 between">
                <el-checkbox v-model="checked">下次自动登录</el-checkbox>
                <div>
                  <span class="forget c9 pointer mr10" @click="register">注册</span>
                  <span class="forget c9 pointer" @click="forgetPass">忘记密码</span>
                </div>
              </div>
            </el-form-item>
            <el-button type="primary" class="login_btn w100 fs18" @click="submitForm('form')">登录</el-button>
          </el-form>
          <el-form v-else ref="codeForm" :model="codeForm" :rules="codeRules" class="login-form">
            <el-form-item prop="account">
              <el-input v-model.trim="codeForm.account" type="text" placeholder="请输入手机号" maxlength="11" clearable prefix-icon="el-icon-mobile" @input="inputAccount" />
            </el-form-item>
            <el-form-item v-if="codeForm.account && slideDrawing" prop="slide">
              <div class="flex_center c6 success_button">
                <i class="el-icon-check mr5 fs16" />
                验证成功
              </div>
            </el-form-item>
            <el-form-item v-else prop="slide">
              <div class="flex_center c6 check_button" @click="slideCheck">
                <i class="el-icon-help mr5 fs16" />
                点击按钮完成验证
              </div>
            </el-form-item>
            <el-form-item prop="code">
              <div class="flex_middle">
                <el-input v-model.trim="codeForm.code" type="text" placeholder="请输入验证码" maxlength="4" clearable prefix-icon="el-icon-message" @input="codeForm.code = codeForm.code.replace(/\D/g, '')" />
                <el-button v-if="!isSend" style="height: 40px;" class="active_color ml20" :disabled="codeForm.account && !slideDrawing" @click="getCode">{{ str }}</el-button>
                <el-button v-if="isSend" style="height: 40px;" class="ml20" disabled>{{ countStr }}</el-button>
              </div>
            </el-form-item>
            <el-form-item>
              <div class="w100 between">
                <el-checkbox v-model="checked">下次自动登录</el-checkbox>
              </div>
            </el-form-item>
            <el-button type="primary" class="login_btn w100 fs18" @click="submit('codeForm')">登录</el-button>
          </el-form>
        </template>
        <div v-else class="wh100">
          <div class="title fs18 bold center mb22">选择公司</div>
          <ul class="company-list">
            <li v-for="v in companyList" :key="v.company_id" class="center pointer" @click="selectCompany(v.company_id)">{{ v.company_name }}</li>
          </ul>
        </div>
        <!-- </div> -->
        <!-- <div v-if="isCode && isFirst">
         <ul class="tabList pointer flex_middle">
          <li class="lh36 fs18 c6 active">验证码登录</li>
        </ul>
       <el-form ref="codeForm" :model="codeForm" :rules="codeRules" class="login-form">
            <el-form-item prop="account">
              <el-input v-model.trim="codeForm.account" type="text" placeholder="请输入手机号" maxlength="11" clearable prefix-icon="el-icon-mobile" @input="codeForm.account = codeForm.account.replace(/\D/g, '')" />
            </el-form-item>
            <el-form-item prop="code">
              <div class="flex_middle">
                <el-input v-model.trim="codeForm.code" type="text" placeholder="请输入验证码" maxlength="4" clearable prefix-icon="el-icon-message" @input="codeForm.code = codeForm.code.replace(/\D/g, '')" />
                <el-button v-if="!isSend" style="height: 40px;" class="active_color ml20" @click="getCode">{{ str }}</el-button>
                <el-button v-if="isSend" style="height: 40px;" class="ml20" disabled>{{ countStr }}</el-button>
              </div>
            </el-form-item>
            <el-form-item>
              <div class="w100 between">
                <el-checkbox v-model="checked">下次自动登录</el-checkbox>
              </div>
            </el-form-item>
            <el-button type="primary" class="login_btn w100 fs18" @click="getSweepCodeLogin('codeForm')">绑定</el-button>
          </el-form>
        </div> -->
        <!-- <div v-if="isCode && !isFirst" class="flex_center">
          <div id="code_link"></div>
        </div> -->
        <edit-pass title="修改密码" :visible.sync="editPassDialog" width="400px" @submit="submitEdit" />
      </div>
    </div>
    <el-dialog :visible.sync="slideShow" width="420px">
      <slide-verify
        ref="slideblock"
        :l="42"
        :r="10"
        :w="380"
        :h="155"
        slider-text="请向右滑动滑块完成验证"
        :imgs="puzzleImgList"
        @success="onSuccess"
        @fail="onFail"
        @refresh="onRefresh"
        @fulfilled="onFulfilled"
      />
      <div class="mt5" :class=" msg == '验证成功' ? 'checkactive' : 'del'">{{ msg }}</div>
    </el-dialog>
    <el-dialog :visible.sync="systemNode" title="安全登录" width="480px" :before-close="beforeClose">
      <div class="login_right">
        <div class="mb22">您的账号登录环境发生变化，为确保本人操作，请进行短信验证登录。</div>
        <el-form ref="systemForm" :model="systemForm" :rules="systemRules" class="login-form">
          <el-form-item prop="account">
            <el-input v-model="systemForm.account" type="text" placeholder="请输入手机号" maxlength="11" prefix-icon="el-icon-mobile" disabled @input="systemForm.account = systemForm.account.replace(/\D/g, '')" />
          </el-form-item>
          <el-form-item prop="code">
            <div class="flex_middle">
              <el-input v-model="systemForm.code" type="text" placeholder="请输入验证码" maxlength="4" clearable prefix-icon="el-icon-message" @input="systemForm.code = systemForm.code.replace(/\D/g, '')" />
              <el-button v-if="!sysIsSend" style="height: 40px;" class="active_color ml20" @click="getSystemCode">{{ systemStr }}</el-button>
              <el-button v-if="sysIsSend" style="height: 40px;" class="ml20" disabled>{{ sysCountStr }}</el-button>
            </div>
          </el-form-item>
          <el-button type="primary" class="login_btn w100 fs18" @click="submitSystem('systemForm')">登录</el-button>
        </el-form>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import EditPass from '@/layout/components/EditPassword'
import { sendsmsCode } from '@/api/common'
import { getCurVersion, getSweepCodeUserInfo, firstSweepLogin } from '@/api/user'
import { get, set, clearAll } from '@/utils/storage'
import { mapActions, mapGetters, mapMutations, mapState } from 'vuex'

export default {
  components: {
    EditPass
  },
  data() {
    const validateMobile = (rule, value, callback) => {
      if (!value) {
        callback(new Error('请输入手机号'))
      } else {
        if (!/^1[3456789]\d{9}$/.test(value)) {
          callback(new Error('请输入正确的手机号'))
        } else {
          callback()
        }
      }
    }
    const validateSlide = (rule, value, callback) => {
      if (!this.codeForm.account) {
        callback(new Error('请先输入手机号'))
      } else if (!/^1[3456789]\d{9}$/.test(this.codeForm.account)) {
        callback(new Error('请先输入正确的手机号'))
      } else if (!this.code && !this.slideDrawing) {
        callback(new Error('请先点击按钮完成验证'))
      } else {
        callback()
      }
    }
    const validateFormSlide = (rule, value, callback) => {
      if (!this.form.account) {
        callback(new Error('请先输入账号'))
      } else if (!this.form.pass) {
        callback(new Error('请先输入密码'))
      } else if (!this.slideFormDrawing) {
        callback(new Error('请先点击按钮完成验证'))
      } else {
        callback()
      }
    }
    const validateRegcode = (rule, value, callback) => {
      if (!this.codeForm.account) {
        callback(new Error('请先输入手机号'))
      } else if (!this.code) {
        callback(new Error('请先获取短信验证码'))
      } else if (!value) {
        callback(new Error('请输入验证码'))
      } else {
        callback()
      }
    }
    const validateSysMobile = (rule, value, callback) => {
      if (!value) {
        callback(new Error('请输入手机号'))
      } else {
        if (!/^1[3456789]\d{9}$/.test(value)) {
          callback(new Error('请输入正确的手机号'))
        } else {
          callback()
        }
      }
    }
    const validateSysRegcode = (rule, value, callback) => {
      if (!this.systemForm.account) {
        callback(new Error('请先输入手机号'))
      } else if (!this.systemCode) {
        callback(new Error('请先获取短信验证码'))
      } else if (!value) {
        callback(new Error('请输入验证码'))
      } else {
        callback()
      }
    }
    return {
      isMultiple: false, // 是否多公司
      activeIndex: 0,
      form: {
        account: '',
        pass: ''
      },
      rules: {
        account: [{ required: true, message: '请输入账号', trigger: 'change' }],
        pass: [{ required: true, message: '请输入密码', trigger: 'change' }],
        slide: [{ required: true, validator: validateFormSlide, trigger: 'change' }]
      },
      checked: true,
      codeForm: {
        account: '',
        code: ''
      },
      systemForm: {
        account: '',
        code: ''
      },
      codeRules: {
        account: [{ required: true, validator: validateMobile, trigger: 'change' }],
        slide: [{ required: true, validator: validateSlide, trigger: 'change' }],
        code: [{ required: true, validator: validateRegcode, trigger: 'change' }]
      },
      systemRules: {
        account: [{ required: true, validator: validateSysMobile, trigger: 'change' }],
        code: [{ required: true, validator: validateSysRegcode, trigger: 'change' }]
      },
      code: '',
      str: '获取验证码',
      countStr: '重新发送（60s）',
      isSend: false,
      timer: null,
      systemCode: '',
      systemStr: '获取验证码',
      sysCountStr: '重新发送（60s）',
      sysIsSend: false,
      systemTimer: null,
      companyList: [],
      editPassDialog: false,
      loginType: 1, // 登陆类型： 1.账号密码登陆 2.验证码登陆, 3二维码登录
      isCode: false,
      isFirst: false,
      iswxName: false,
      wxCode: '',
      wxState: '',
      openid: '',
      wxuserInfo: {},
      system: {
        system_version: '', // 系统版本
        system_name: '', // 系统名称
        browser_version: '', // 浏览器版本
        browser_name: '', // 浏览器名称
        browser_core: '' // 浏览器内核信息
      },
      msg: '',
      slideShow: false,
      slideDrawing: false,
      slideFormDrawing: false,
      slideText: '请向右滑动滑块完成验证',
      puzzleImgList: [
        require('@/assets/check2.png'),
        require('@/assets/check5.png'),
        require('@/assets/check4.jpg'),
        require('@/assets/check3.jpg'),
        require('@/assets/check1.png'),
        require('@/assets/check7.jpg'),
        require('@/assets/check8.jpg'),
        require('@/assets/check6.jpg')
      ]
    }
  },
  computed: {
    ...mapState('user', ['systemNode']),
    ...mapGetters('user', ['version', 'updateVersion', 'versionContent', 'nodeAuth']),
    systemNode: {
      get() {
        this.systemForm.account = this.form.account
        if (this.$store.state.user.systemNode && this.systemForm.account) {
          this.getSystemCode()
        }
        return this.$store.state.user.systemNode
      },
      set(val) {
        this.$store.state.user.systemNode = val
      }
    }
  },
  created() {
    // 自动登录
    if (get(process.env.VUE_APP_STORAGE_USERINFO) && get('autoLogin') === 'true') {
      this.routerDump()
    }
  },
  mounted() {
    this.getOsInfo()
    this.getBrowerInfo()
    // if (this.$route.query.code && this.$route.query.wxstate) {
    //   this.wxCode = this.$route.query.code;
    //   this.wxState = this.$route.query.wxstate;
    //   this.getSweepCodeUserInfo()
    // }
  },
  methods: {
    ...mapActions('user', ['smslogin', 'loginFn', 'wxlogin']),
    ...mapMutations('user', ['SET_UPDATEVERSION', 'SET_VERSIONCONTENT', 'SET_VERSION']),
    getOsInfo() {
      var userAgent = navigator.userAgent.toLowerCase()
      this.system.system_name = 'Unknown'
      this.system.system_version = 'Unknown'
      if (userAgent.indexOf('win') > -1) {
        this.system.system_name = 'Windows'
        if (userAgent.indexOf('windows nt 5.0') > -1) {
          this.system.system_version = 'Windows 2000'
        } else if (userAgent.indexOf('windows nt 5.1') > -1 || userAgent.indexOf('windows nt 5.2') > -1) {
          this.system.system_version = 'Windows XP'
        } else if (userAgent.indexOf('windows nt 6.0') > -1) {
          this.system.system_version = 'Windows Vista'
        } else if (userAgent.indexOf('windows nt 6.1') > -1 || userAgent.indexOf('windows 7') > -1) {
          this.system.system_version = 'Windows 7'
        } else if (userAgent.indexOf('windows nt 6.2') > -1 || userAgent.indexOf('windows 8') > -1) {
          this.system.system_version = 'Windows 8'
        } else if (userAgent.indexOf('windows nt 6.3') > -1) {
          this.system.system_version = 'Windows 8.1'
        } else if (userAgent.indexOf('windows nt 6.2') > -1 || userAgent.indexOf('windows nt 10.0') > -1) {
          this.system.system_version = 'Windows 10'
        } else {
          this.system.system_version = 'Unknown'
        }
      } else if (userAgent.indexOf('iphone') > -1) {
        this.system.system_name = 'Iphone'
      } else if (userAgent.indexOf('mac') > -1) {
        this.system.system_name = 'Mac'
      } else if (userAgent.indexOf('x11') > -1 || userAgent.indexOf('unix') > -1 || userAgent.indexOf('sunname') > -1 || userAgent.indexOf('bsd') > -1) {
        this.system.system_name = 'Unix'
      } else if (userAgent.indexOf('linux') > -1) {
        if (userAgent.indexOf('android') > -1) {
          this.system.system_name = 'Android'
        } else {
          this.system.system_name = 'Linux'
        }
      } else {
        this.system.system_name = 'Unknown'
      }
    },
    // 获取浏览器相关信息
    getBrowerInfo() {
      var Browser = Browser || (function(window) {
        var document = window.document,
          navigator = window.navigator,
          agent = navigator.userAgent.toLowerCase(),
          // IE8+支持.返回浏览器渲染当前文档所用的模式
          // IE6,IE7:undefined.IE8:8(兼容模式返回7).IE9:9(兼容模式返回7||8)
          // IE10:10(兼容模式7||8||9)
          IEMode = document.documentMode,
          // chorme
          chrome = window.chrome || false,
          System = {
            // user-agent
            agent: agent,
            // 是否为IE
            isIE: /trident/.test(agent),
            // Gecko内核
            isGecko: agent.indexOf('gecko') > 0 && agent.indexOf('like gecko') < 0,
            // webkit内核
            isWebkit: agent.indexOf('webkit') > 0,
            // 是否为标准模式
            isStrict: document.compatMode === 'CSS1Compat',
            // 是否支持subtitle
            supportSubTitle: function() {
              return 'track' in document.createElement('track')
            },
            // 是否支持scoped
            supportScope: function() {
              return 'scoped' in document.createElement('style')
            },
            // 获取IE的版本号
            ieVersion: function() {
              var rMsie = /(msie\s|trident.*rv:)([\w.]+)/
              var ma = window.navigator.userAgent.toLowerCase()
              var match = rMsie.exec(ma)
              try {
                return match[2]
              } catch {
                return IEMode
              }
            },
            // Opera版本号
            operaVersion: function() {
              try {
                if (window.opera) {
                  return agent.match(/opera.([\d.]+)/)[1]
                } else if (agent.indexOf('opr') > 0) {
                  return agent.match(/opr\/([\d.]+)/)[1]
                }
              } catch {
                return 0
              }
            }
          }
        try {
          // 浏览器类型(IE、Opera、Chrome、Safari、Firefox)
          System.type = System.isIE ? 'IE' :
            window.opera || (agent.indexOf('opr') > 0) ? 'Opera' :
              (agent.indexOf('chrome') > 0) ? 'Chrome' :
              // safari也提供了专门的判定方式
                window.openDatabase ? 'Safari' :
                  (agent.indexOf('firefox') > 0) ? 'Firefox' : 'unknow'
          // 版本号
          System.version = (System.type === 'IE') ? System.ieVersion() :
            (System.type === 'Firefox') ? agent.match(/firefox\/([\d.]+)/)[1] :
              (System.type === 'Chrome') ? agent.match(/chrome\/([\d.]+)/)[1] :
                (System.type === 'Opera') ? System.operaVersion() :
                  (System.type === 'Safari') ? agent.match(/version\/([\d.]+)/)[1] : '0'
          // 浏览器外壳
          System.shell = function() {
            if (agent.indexOf('edge') > 0) {
              System.version = agent.match(/edge\/([\d.]+)/)[1] || System.version
              return 'edge浏览器'
            }
            // 遨游浏览器
            if (agent.indexOf('maxthon') > 0) {
              System.version = agent.match(/maxthon\/([\d.]+)/)[1] || System.version
              return '傲游浏览器'
            }
            // QQ浏览器
            if (agent.indexOf('qqbrowser') > 0) {
              System.version = agent.match(/qqbrowser\/([\d.]+)/)[1] || System.version
              return 'QQ浏览器'
            }
            // 搜狗浏览器
            if (agent.indexOf('se 2.x') > 0) {
              return '搜狗浏览器'
            }
            // Chrome:也可以使用window.chrome && window.chrome.webstore判断
            if (chrome && System.type !== 'Opera') {
              var external = window.external,
                clientInfo = window.clientInformation,
                // 客户端语言:zh-cn,zh.360下面会返回undefined
                clientLanguage = clientInfo.languages
                // 猎豹浏览器:或者agent.indexOf('lbbrowser')>0
              if (external && 'LiebaoGetVersion' in external) {
                return '猎豹浏览器'
              }
              // 百度浏览器
              if (agent.indexOf('bidubrowser') > 0) {
                System.version = agent.match(/bidubrowser\/([\d.]+)/)[1] ||
                agent.match(/chrome\/([\d.]+)/)[1]
                return '百度浏览器'
              }
              // 360极速浏览器和360安全浏览器
              if (System.supportSubTitle() && typeof clientLanguage === 'undefined') {
                // object.key()返回一个数组.包含可枚举属性和方法名称
                var storeKeyLen = Object.keys(chrome.webstore).length,
                  v8Locale = 'v8Locale' in window
                return storeKeyLen > 1 ? '360极速浏览器' : '360安全浏览器'
              }
              return 'Chrome'
            }
            return System.type
          }
          // 浏览器名称(如果是壳浏览器,则返回壳名称)
          System.name = System.shell()
        } catch(e) {
          console.log(e.message)
        }
        return {
          client: System
        }
      })(window)
      if (Browser.client.name == undefined || Browser.client.name == '') {
        Browser.client.name = 'Unknown'
        Browser.client.version = 'Unknown'
      } else if (Browser.client.version == undefined) {
        Browser.client.version = 'Unknown'
      }
      this.system.browser_name = Browser.client.name
      this.system.browser_version = Browser.client.version
      this.system.browser_core = Browser.client.agent
    },
    onSuccess() {
      this.msg = '验证成功'
      setTimeout(() => {
        this.slideShow = false
        if (this.activeIndex == 0) {
          this.slideFormDrawing = true
          this.$refs.form.validateField('slide')
        } else {
          this.slideDrawing = true
          this.$refs.codeForm.validateField('slide')
        }
        this.slideText = '验证成功'
      }, 1000)
    },
    onFail() {
      this.msg = '验证失败'
    },
    onRefresh() {
      this.msg = ''
    },
    onFulfilled() {
      this.msg = ''
    },
    slideCheck() {
      this.$refs.codeForm.validateField(['account'], (err) => {
        if (!err) {
          this.slideShow = true
          this.$nextTick(() => {
            this.$refs.slideblock.reset()
          })
        }
      })
    },
    slideFormCheck() {
      this.$refs.form.validateField('account', (err) => {
        if (!err) {
          this.$refs.form.validateField('pass', (passerr) => {
            if (!passerr) {
              this.slideShow = true
              this.$nextTick(() => {
                this.$refs.slideblock.reset()
              })
            } else {
              return false
            }
          })
        } else {
          return false
        }
      })
    },
    inputAccount() {
      this.codeForm.account = this.codeForm.account.replace(/\D/g, '')
      if (!this.codeForm.account) {
        this.slideDrawing = false
      }
    },
    inputPass() {
      if (!this.form.account || !this.form.pass) {
        this.slideFormDrawing = false
      }
    },
    next() {
      this.$refs.pass.focus()
    },
    toggleTab(i) {
      if (this.$refs.codeForm) {
        this.$refs.codeForm.clearValidate()
      }
      if (this.$refs.form) {
        this.$refs.form.clearValidate()
      }
      this.activeIndex = i
      if (i === 0) {
        this.slideFormDrawing = false
        this.$nextTick(() => {
          this.$refs.form.clearValidate(['account', 'pass'])
        })
      } else {
        this.slideDrawing = false
        this.$nextTick(() => {
          this.$refs.codeForm.clearValidate(['account', 'code'])
        })
      }
    },
    register() {
      if (this.$route.query.code) {
        this.$router.push('/register?code=' + this.$route.query.code)
      } else {
        this.$router.push('/register')
      }
    },
    getSweepCodeUserInfo() {
      getSweepCodeUserInfo({ code: this.wxCode, state: this.wxState }).then(res => {
        if (res.code === 200) {
          this.wxuserInfo = res.data
          firstSweepLogin({ openid: res.data.openid }).then(res => {
            if (res.code === 200) {
              if (res.data.is_first == 1) {
                this.isFirst = true
                this.isCode = true
                this.iswxName = true
                this.activeIndex = 2
              } else {
                this.isFirst = false
                this.getWxCompany()
              }
            }
          })
        }
      })
    },
    getSweepCodeLogin(formName) {
      this.$refs[formName].validate(async valid => {
        if (valid) {
          this.getWxCompany()
          return true
        } else {
          return false
        }
      })
    },
    getWxCompany() {
      this.wxlogin({ ...this.wxuserInfo, ...this.codeForm, login_type: 2 }).then(res => {
        if (res.code === 200) {
          this.loginType = 3
          if (this.timer) {
            clearInterval(this.timer)
          }
          if (res.data.length > 0 && Array.isArray(res.data)) {
            // 账号包含多个子公司
            this.iswxName = true
            this.isCode = false
            this.isMultiple = true
            this.companyList = res.data
          } else {
            this.login(res.data, this.loginType)
          }
        }
      })
    },
    getCode() {
      this.$refs.codeForm.validateField('account', (err) => {
        if (!err) {
          sendsmsCode({ account: this.codeForm.account }).then(res => {
            if (res.code === 200) {
              this.code = 1
              this.isSend = true
              this.timer = null
              let time = 60
              this.timer = setInterval(() => {
                if (time === 0) {
                  this.str = '重新获取验证码'
                  this.countStr = '重新发送（60s）'
                  this.isSend = false
                  clearInterval(this.timer)
                } else {
                  time--
                  this.countStr = `重新发送（${time}s）`
                }
              }, 1000)
            }
          })
        }
      })
    },
    getSystemCode() {
      sendsmsCode({ account: this.systemForm.account }).then(res => {
        if (res.code === 200) {
          this.systemCode = 1
          this.sysIsSend = true
          let time = 60
          this.systemTimer = setInterval(() => {
            if (time === 0) {
              this.systemStr = '重新获取验证码'
              this.sysCountStr = '重新发送（60s）'
              this.sysIsSend = false
              clearInterval(this.systemTimer)
            } else {
              time--
              this.sysCountStr = `重新发送（${time}s）`
            }
          }, 1000)
        }
      })
    },
    beforeClose(done) {
      this.systemCode = ''
      this.systemStr = '重新获取验证码'
      this.sysCountStr = '重新发送（60s）'
      this.sysIsSend = false
      clearInterval(this.systemTimer)
      this.$refs.systemForm.resetFields()
      this.$store.state.user.systemNode = false
      done()
    },
    submitForm(formName) {
      this.$refs[formName].validate(async valid => {
        if (valid) {
          const res = await this.loginFn({ ...this.form, ...this.system })
          if (res.code === 200) {
            this.loginType = 1
            if (this.timer) {
              clearInterval(this.timer)
            }
            if (res.data && Array.isArray(res.data)) {
              // 账号包含多个子公司
              this.isMultiple = true
              this.companyList = res.data
            } else {
              this.login(res.data, this.loginType)
            }
          }
        } else {
          return false
        }
      })
    },
    submit(formName) {
      this.$refs[formName].validate(async valid => {
        if (valid) {
          const res = await this.smslogin({ ...this.codeForm, ...this.system })
          if (res.code === 200) {
            this.loginType = 2
            if (this.timer) {
              clearInterval(this.timer)
            }
            if (res.data && Array.isArray(res.data)) {
              // 账号包含多个子公司
              this.isMultiple = true
              this.companyList = res.data
            } else {
              this.login(res.data, this.loginType)
            }
          }
        } else {
          return false
        }
      })
    },
    submitSystem(formName) {
      this.$refs[formName].validate(async valid => {
        if (valid) {
          const res = await this.smslogin({ ...this.systemForm, ...this.system })
          if (res.code === 200) {
            this.loginType = 4
            if (this.systemTimer) {
              clearInterval(this.systemTimer)
            }
            this.$store.state.user.systemNode = false
            if (res.data && Array.isArray(res.data)) {
              // 账号包含多个子公司
              this.isMultiple = true
              this.companyList = res.data
            } else {
              this.login(res.data, this.loginType)
            }
          }
        } else {
          return false
        }
      })
    },
    login(res, type) {
      console.log(res, 'res')
      if (this.timer) { clearInterval(this.timer) }
      if (type === 1 && this.form.pass === '888888') {
        set('pass', 'default')
        this.editPassDialog = true
        return false
      }
      this.routerDump()
    },
    async routerDump() {
      const res = await getCurVersion()
      if (res.code === 200) {
        const oldVersion = get('version')
        if (oldVersion && oldVersion.toLowerCase() !== res.data.version.toLowerCase() || !oldVersion) {
          // 更新内容描述
          this.SET_VERSIONCONTENT(res.data.employer_desc)
          // 显示弹框
          this.SET_UPDATEVERSION(true)
          // 本地存储版本号
          set('version', res.data.version)
        }
        set('autoLogin', this.checked) // 自动登录
        set('pass', 'define')
        // 权限列表
        if (this.nodeAuth.length) {
          this.$router.replace('/home')
        } else {
          this.$message.error('暂无任何权限,请联系超级管理员')
        }
      } else {
        clearAll()
      }
    },
    submitEdit() {
      if (this.isMultiple) {
        this.isMultiple = false
        this.companyList = []
      }
    },
    forgetPass() {
      if (this.timer) { clearInterval(this.timer) }
      this.$router.push({ path: '/findpass' })
    },
    // 选择公司
    async selectCompany(id) {
      if (this.loginType === 1) {
        const res = await this.loginFn({ ...this.form, company_id: id, ...this.system })
        if (res.code === 200) {
          this.login(res.data, this.loginType)
        }
      } else if (this.loginType === 2) {
        const res = await this.smslogin({ ...this.codeForm, company_id: id, ...this.system })
        if (res.code === 200) {
          this.login(res.data, this.loginType)
        }
      } else if (this.loginType === 3) {
        const res = await this.wxlogin({ ...this.wxuserInfo, ...this.codeForm, company_id: id, login_type: 2 })
        if (res.code === 200) {
          this.login(res.data, this.loginType)
        }
      } else {
        const res = await this.smslogin({ ...this.systemForm, company_id: id, ...this.system })
        if (res.code === 200) {
          this.login(res.data, this.loginType)
        }
      }
    },
    showCode() {
      this.isCode = !this.isCode
      this.iswxName = !this.iswxName
      this.$nextTick(() => {
        new WxLogin({
          self_redirect: false,
          id: 'code_link',
          appid: 'wx691b2d0e0abfb20b',
          scope: 'snsapi_login',
          redirect_uri: 'https%3A%2F%2Ftest.chonghai.net%3A8001',
          state: Math.ceil(Math.random() * 1000) + '_jfClient',
          style: '',
          href: ''
        })
      })
    },
    showAccount() {
      this.isCode = !this.isCode
      this.iswxName = !this.iswxName
      if (this.wxCode) {
        this.activeIndex = 0
        this.isFirst = false
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.login{
  min-width: 1260px;
  min-height: 600px;
  background-image: url('../../assets/login_new_bg.png');
  background-size: 100% 100%;
  background-repeat: no-repeat;
  .wrap{
    width: 900px;
    height: 480px;
    border-radius: 10px;
    box-shadow: 0 1px 14px 2px rgba(45, 140, 240, 0.09);
    .login_left{
      width: 420px;
      height: 480px;
    }
    .login_left_img{
      border-radius: 10px 0 0 10px;
    }
    .login_right{
      padding: 40px 50px;
      position: relative;
      .login_code_pr{
        position: absolute;
        right: 20px;
        top: 20px;
      }
      .check_button{
        width: 100%;
        border-radius: 2px;
        border: 1px solid #e4e7eb;
        background-color: #f7f9fa;
        font-size: 14px;
        cursor: pointer;
      }
      .check_button:hover{
        color: #1890FF;
      }
      .success_button{
        width: 100%;
        border-radius: 2px;
        border:1px solid #52ccba;
        background-color: #d2f4ef;
        color: #52ccba;
        font-size: 14px;
        cursor: pointer;
      }
      .login_code{
        width: 35px;
        // height: 43px;
        img{
          width: 100%;
          height: 100%;
        }
      }
      .tabList{
        margin: 0;
        margin-bottom: 35px;
        li{
          &.active{
            font-weight: 600;
            // color: #333;
            color: #1890FF;
            &::after{
              width: 100%;
              height: 2px;
              border-radius: 2px;
              background: #2d8cf0;
              content: "";
              display: block;
              position: relative;
              top: 0px;
              margin: 0 auto;
            }
          }
        }
        .el-divider--vertical{
          margin: 0 18px;
        }
      }
      .login-form{
        .el-input--medium .el-input__inner{
          height: 66px;
          line-height: 66px;
          border: none;
          border-radius: 0;
          border-bottom: 1px solid #e8e8e8;
        }
        .el-input__prefix{
          left: -5px;
        }
        .el-input--medium .el-input__icon{
          font-size: 17px;
          padding-top: 2px;
        }
        .forget{
          &:hover{
            color: #2d8cf0;
          }
        }
        .login_btn{
          height: 46px;
          margin-top: 35px;
        }
      }
      .company-list{
        height: calc(100% - 46px);
        overflow-x: hidden;
        overflow-y: auto;
        margin: 0;
        li{
          height: 40px;
          line-height: 40px;
          background-color: #f8f8f8;
          margin-bottom: 10px;
          &:hover{
            background-color: #eee;
          }
        }
      }
    }
  }
}
::v-deep .el-input.is-disabled .el-input__inner{
  color: #606266;
  cursor: not-allowed;
  background-image: none;
  background-color: #FFF;
  border-color: #EBEEF5;
}
.checkactive{
  color: #52ccba;
}
</style>
